// Presentation metadata of a Datanodes implementation (one x-chain slug of a
// network) — shared by the network page, the sidebar and the catalog.
import { FAMILIES } from "../../data/apiReference";
import { SUI_BLOCKS } from "../../data/suiReference";
import { slugify } from "./DocBlocks";

// "Tendermint RPC", "JSON-RPC + WebSocket", "GraphQL · gRPC", …
export const implLabel = (chain) => {
  const fam = FAMILIES[chain.family];
  return chain.ws ? `${fam.protocol} + WebSocket` : fam.protocol;
};

// Section anchors rendered by the implementation body (see NetworkPage).
export const implSections = (chain) => {
  if (chain.dedicated) return SUI_BLOCKS.filter((b) => b.type === "heading").map((b) => ({ id: slugify(b.text), text: b.text }));
  const grpc = chain.family === "solana";
  return [
    { id: "overview", text: "Overview" },
    { id: "endpoints", text: "Endpoints & headers" },
    { id: "examples", text: `Calling ${chain.name}` },
    { id: "methods", text: "Methods" },
    ...(chain.ws ? [{ id: "websocket", text: "WebSocket" }] : []),
    ...(grpc ? [{ id: "grpc", text: "gRPC streams" }] : []),
    { id: "limits", text: "Rate limits & errors" },
  ];
};
